import React, { useState } from "react";
import "./Partners.css";
import { useNavigate } from "react-router-dom";
const getClassificationClass = (classification) => {
    switch (classification) {
      case "Platinum Partner":
        return "platinum";
      case "Gold Partner":
        return "gold";
      case "Silver Partner":
        return "silver";
      default:
        return "";
    }
  };
  const Card = ({ imgSrc, companyName, companyCountry, companyAbout, classification,Url ,email}) => {
    const navigate = useNavigate();

    const handleClick = () => {
      const formattedName = companyName.toLowerCase().replace(/\s+/g, '-');
      navigate(`/partners/${formattedName}`, { state: { companyName, companyCountry, companyAbout, classification, imgSrc, Url, email } });
    };
    return (
      <div className={`col-xl-6 col-md-6 col-sm-12 card-partner`}>
        <a onClick={handleClick}>
        <div className="content-card">
        <span>
          <img src={imgSrc} alt={companyName} />
        </span>
        <p className="content-card-name">{companyName}</p>
        <p className="content-card-country">{companyCountry}</p>
        <p className="content-card-about">{companyAbout}</p>
        <div className="footer-card">
          <div className="classification-partner">
            <span className={`text-classification-partner ${getClassificationClass(classification)}`}>{classification}</span>
          </div>
          <div className="view-profile">
            Ver Perfil ➔
          </div>
        </div>
      </div>
        </a>
      </div>
    );
  };
const Partners = ({ filteredCardsData,totalData }) => {
  const [visibleCount, setVisibleCount] = useState(9);

  const handleShowMore = () => {
    setVisibleCount(prevCount => prevCount + 9);
  };

  const visibleCards = filteredCardsData.slice(0, visibleCount);
  
  if (filteredCardsData.length === 0) {
    return <p>No se encontraron socios que coincidan con la búsqueda.</p>;
  }

  return (
    <div className="container">
      <div className="row">
        {visibleCards.map((card, index) => (
          <Card key={index} {...card}  totalData={totalData}/>
        ))}
      </div>
      {visibleCount < filteredCardsData.length && (
        <div className="show-more-container">
          <button className="show-more-button" onClick={handleShowMore}>
            Mostrar más
          </button>
        </div>
      )}
    </div>
  );
};

export default Partners;